import { useState, useEffect } from 'react';
import { parseWordpressResponseJson } from '@/utils/parseWordpressJson';

export const usePosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://blog.disgenet.com/wp-json/wp/v2/posts?_embed')
      .then(res => {
        if (!res.ok) {
          throw new Error('Posts request failed');
        }
        return parseWordpressResponseJson(res);
      })
      .then(data => {
        if (!Array.isArray(data)) {
          throw new Error('Unexpected posts response');
        }
        const formatted = data.map(post => ({
          title: post.title.rendered,
          postName: post.slug,
          link: post.link,
          date: new Date(post.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }),
          image: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '/static/images/blog/default.jpg', // fallback si no hay imagen
          description: post.excerpt?.rendered?.replace(/<[^>]+>/g, '').slice(0, 200) + ' [...]',
        }));
        setPosts(formatted);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching posts:', err);
        setLoading(false);
      });
  }, []);

  return { posts, loading };
};
